export default __webpack_public_path__ + "static/media/payment-error.aa822269.png";